import React from 'react'
import Sidebar from '../components/Sidebar'
import RecentFeed from '../sections/RecentFeed'
import "../styles/pageStyles/Recent.scss"

const Recent = () => {
    return (
        <div className='recent'>
            <Sidebar />
            <div className="recent__content-container">
                <RecentFeed />
            </div>
        </div>
    )
}

export default Recent